import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'dark' | 'outline' | 'outline-light'

type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonStyleOptions {
    variant?: ButtonVariant
    size?: ButtonSize
    className?: string
}

const BASE = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-60'

const VARIANTS: Record<ButtonVariant, string> = {
    primary: 'bg-primary text-primary-foreground shadow-sm shadow-aqua-deep/20 hover:bg-aqua-strong',
    dark: 'bg-ink text-white hover:bg-ink-soft',
    outline: 'border border-input bg-card text-foreground hover:border-ink/40 hover:bg-foam',
    'outline-light': 'border border-white/25 text-white hover:border-white/50 hover:bg-white/10'
}

const SIZES: Record<ButtonSize, string> = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-5 text-[0.95rem]',
    lg: 'h-12 px-6 text-base sm:h-13 sm:px-7'
}

// Shared button look for links and buttons, so every call to action matches.
export const buttonStyles = ({ variant = 'primary', size = 'md', className }: ButtonStyleOptions = {}): string =>
    cn(BASE, VARIANTS[variant], SIZES[size], className)
